export default "__VITE_ASSET__CNzjgOkz__"